import { useWatch } from 'react-hook-form';
import { QtyWarning, calculateTotalFormQuantity, getQuantityWarning } from '~/components/BillModal/components/BillServiceTableItem/BillServiceTableItem.utils';
import { validateAmountGreaterThan0 } from '../../utils/lineItem.utils';
export const useOverPreapprovedWarning = (item, rowIndex, params)=>{
    var _useWatch;
    const { manualServicesBilling, relationshipEffectiveDate } = params;
    const items = (_useWatch = useWatch({
        control: params.control,
        name: 'items'
    })) !== null && _useWatch !== void 0 ? _useWatch : [];
    const issueDate = useWatch({
        control: params.control,
        name: 'issueDate'
    });
    const rowQuantity = useWatch({
        control: params.control,
        name: "items.".concat(rowIndex, ".service.quantity")
    });
    if (validateAmountGreaterThan0(rowQuantity) !== undefined) return false;
    return getQuantityWarning({
        service: item.fullService,
        quantity: calculateTotalFormQuantity(items, item.fullService.id),
        issueDate,
        manualServiceBilling: manualServicesBilling === null || manualServicesBilling === void 0 ? void 0 : manualServicesBilling[item.fullService.id],
        relationshipEffectiveDate
    }) === QtyWarning.Billed;
};
